import './WifiNetworkCard.css';

import React from 'react';
import { WifiOn, Lock } from '@src/assets';
import { type WifiNetwork } from '@lib/networkApiTypes';

interface WifiNetworkCardProps {
  wifiNetwork: WifiNetwork
  isConnected: boolean
  onClick: () => void
}

export const WifiNetworkCard = ({ wifiNetwork, isConnected, onClick }: WifiNetworkCardProps): JSX.Element => {
  return (
    <div className="wifi_network_card" onClick={onClick}>
      <div className="wifi_network_card_metadata">
        <div className="wifi_network_card_network_name">{wifiNetwork.ssid}</div>
        <div className={`wifi_network_card_connection ${isConnected ? 'connected' : ''}`}>{isConnected ? 'Connected' : 'Not Connected'}</div>
      </div>
      <div className="wifi_network_card_status">
        {wifiNetwork.encryption === 'on' ? <Lock /> : null}
        <WifiOn />
      </div>
    </div>
  );
};
